export var removePrefixAndSuffixFromValue = function (value, prefix, suffix) {
    var tempValue = value;
    if (tempValue) {
        tempValue = String(tempValue).replace(new RegExp(prefix + "|" + suffix, 'g'), '');
    }
    return tempValue;
};
export var addPrefixAndSuffixToValue = function (value, prefix, suffix) {
    var tempValue = value;
    if (suffix)
        tempValue = "" + tempValue + suffix;
    if (prefix)
        tempValue = "" + prefix + tempValue;
    return tempValue;
};
export var addLeadingZero = function (value) {
    if (value < 10) {
        return "0" + value;
    }
    else {
        return "" + value;
    }
};
export var convertTitleToHtmlName = function (title) {
    var _a;
    return (_a = title === null || title === void 0 ? void 0 : title.replace(/ /g, '_')) === null || _a === void 0 ? void 0 : _a.toLowerCase();
};
export var splitStringBySubstring = function (originalString, subString) {
    var loweredSubstring = subString.toLowerCase();
    var loweredOriginalString = originalString === null || originalString === void 0 ? void 0 : originalString.toLowerCase();
    var commonStartIndex = loweredOriginalString === null || loweredOriginalString === void 0 ? void 0 : loweredOriginalString.indexOf(loweredSubstring);
    var startString, commonString, endString;
    // No common string
    if (commonStartIndex === -1) {
        startString = originalString;
    }
    else {
        var commonEndIndex = commonStartIndex + subString.length;
        startString = originalString.slice(0, commonStartIndex);
        commonString = originalString.slice(commonStartIndex, commonEndIndex);
        endString = originalString.slice(commonEndIndex);
    }
    return { startString: startString, commonString: commonString, endString: endString };
};
